// src/App.js
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import About from './pages/About';
import Procedures from './pages/Procedures';
import Resources from './pages/Resources';
import DentalCleaning from './pages/DentalCleaning';
import DentalXrays from './pages/DentalXrays';
import CompositeFilling from './pages/CompositeFilling';
import PFM from './pages/PFM';
import FixedBridges from './pages/FixedBridges';
import PartialDentures from './pages/PartialDentures';
import PeriodontalDiagnosis from './pages/PeriodontalDiagnosis';
import PeriodontalTreatment from './pages/PeriodontalTreatment';

function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/about" element={<About />} />
      <Route path="/procedures" element={<Procedures />} />
      <Route path="/resources" element={<Resources />} />
      <Route path="/procedures/exams-and-cleanings" element={<DentalCleaning />} />
      <Route path="/procedures/x-rays" element={<DentalXrays />} />
      <Route path="/procedures/composite-fillings" element={<CompositeFilling />} />
      <Route path="/procedures/crowns" element={<PFM />} />
      <Route path="/procedures/fixed-bridges" element={<FixedBridges />} /> 
      <Route path="/procedures/partial-dentures" element={<PartialDentures />} />
      <Route path="/procedures/periodontic-diagnosis" element={<PeriodontalDiagnosis />} />
      <Route path="/procedures/periodontic-treatment" element={<PeriodontalTreatment />} />
      {/* Add more routes as needed */}
    </Routes>
  );
}

export default App;
